<template lang="pug">
.twitch__wrap
  h1.twitch__title(v-html="$t('twitch.title')")

  .twitch__login
    .twitch__login-text {{ $t("twitch.connect.login") }}
      i.icon(:class="getIconClass")
    .twitch__login-nickname {{ user.login }}
    .twitch__link(@click="logOut") {{ $t("twitch.connect.change_user") }}

  p.twitch__text {{ $t("twitch.connect.text") }}

  button.button.button--corner.button--red.twitch__button(@click="twitchLink")
    i.icon.icon-social-twitch
    span {{ $t("twitch.connect.button") }}

</template>
<script>
import env from "@godweb/frontend-base/src/libs/tools/Environment";
import { mapState, mapGetters } from "vuex";

export default {
  name: "TwitchConnect",

  computed: {
    ...mapState("global", ["user"]),
    ...mapGetters("global", ["isSteamUser"]),
    getIconClass() {
      return this.isSteamUser ? "icon-social-steam-simple" : "icon-mygames-market";
    },
  },

  methods: {
    twitchLink() {
      let site_name = env.isMyGames() ? "conqblade.com" : "conqblade.ru";
      document.cookie = `chronos_rdr=${document.location.href}; path=/`;
      document.location.href = `https://id.twitch.tv/oauth2/authorize?client_id=dbexlmc8mr56jak4odfl340d9pamu0&redirect_uri=https%3A%2F%2F${site_name}%2Fgw%2Foauth%2Ftwitch%2Fdrops&response_type=code&scope=viewing_activity_read%20user_read&lang=${env.getLang()}`;
    },

    logOut() {
      this.$authService.logout();
    },
  },
};
</script>
